import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e03c1c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "open sm-account overlay_z" };
import Button from '@/materials/atoms/Button.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const { format, ORDER } = useMessage();
        const orderType = (type) => {
            emits('click', type);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Button, {
                    width: "170px",
                    height: "50px",
                    class: "button pd",
                    "color-mode": 'long',
                    "inner-text": _unref(format)(_unref(ORDER).BUY),
                    onClick: _cache[0] || (_cache[0] = ($event) => (orderType('Buy')))
                }, null, 8, ["inner-text"]),
                _createVNode(Button, {
                    width: "170px",
                    height: "50px",
                    class: "button overlay_z",
                    "color-mode": 'short',
                    "inner-text": _unref(format)(_unref(ORDER).SELL),
                    onClick: _cache[1] || (_cache[1] = ($event) => (orderType('Sell')))
                }, null, 8, ["inner-text"])
            ]));
        };
    }
});
